<template xmlns="http://www.w3.org/1999/html">
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <!-- <el-card style="max-height:340px">
              <Leftbar></Leftbar>
            </el-card> -->
            <div class="rightContent">
              <!--              大赛信息-->
              <el-card>
                <h3>{{ $t("competitionInfo.compInfo") }}</h3>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <!-- 删除官方qq群信息展示 -->
                    <!--
                    <p class="info_title">{{ $t("competitionInfo.qq") }}</p>
                    <p
                      v-for="(group, i) in competitionInfo.groups"
                      :key="-1 - i"
                      style="margin-right: 10px"
                    >
                      <span>{{ group.title_cn }}</span> 
                      : {{ group.group_number }}
                    </p>
                    -->
                    <el-tabs type="border-card">
                      <el-tab-pane :label="$t('competitionInfo.helpInfo')">
                        <p
                          v-for="(item, i) in competitionInfo.helpInfo"
                          :key="i"
                        >
                          <el-link
                            :href="item.link"
                            target="_blank"
                            style="color: #337ab6"
                          >
                            <span v-if="$i18n.locale === 'cn'">{{
                              item.title_cn
                            }}</span>
                            <span v-if="$i18n.locale === 'en'">{{
                              item.title_en
                            }}</span>
                          </el-link>
                          <span v-if="item.emphasize" class="new_icon"
                            >NEW</span
                          >
                          <br />
                          <span
                            v-if="item.text_cn"
                            class="text-danger"
                            style="font-size: small; background-color: #f8f1f3"
                          >
                            <span v-if="$i18n.locale === 'cn'">{{
                              item.text_cn
                            }}</span>
                            <span v-if="$i18n.locale === 'en'">{{
                              item.text_en
                            }}</span>
                          </span>
                        </p>
                      </el-tab-pane>
                      <el-tab-pane :label="$t('download.downloadPage')">
                        <p
                          class="info_title"
                          style="margin-top: 0; margin-bottom: 0"
                        >
                          <el-link href="#/download" style="color: #337ab6">
                            {{ $t("download.downloadPage") }}
                          </el-link>
                        </p>
                      </el-tab-pane>
                    </el-tabs>
                  </el-col>
                  <!-- 大赛公众号 -->
                  <el-col :span="12">
                    <p class="info_title" style="text-align: center">
                      {{ $t("competitionInfo.wx") }}
                    </p>
                    <p>
                      <img
                        src="../../assets/img/competition/qrCode.jpg"
                        width="220"
                        style="display: block; margin: 0 auto"
                      />
                      <!--                      <img :src="competitionInfo.qrCode" width="220" />-->
                    </p>
                  </el-col>
                </el-row>
              </el-card>
              <!--              大赛列表-->
              <el-card style="margin-top: 10px">
                <h3>
                  {{ $t("competitionList.compList") }}
                </h3>
                <el-divider></el-divider>
                <el-table
                  :data="competitionList"
                  style="width: 100%"
                  v-loading="loading"
                  stripe
                >
                  <el-table-column prop="name" :label="$t('table.title')">
                    <template slot-scope="scope">
                      <p style="color: black; font-size: 1.2em">
                        {{ scope.row.name }}
                        <span
                          class="competition_notice"
                          @click="competitionNotice(scope.row.id)"
                        >
                          {{ $t("competitionList.contestRule") }}</span
                        >
                      </p>
                      <p style="color: #0065bd">
                        {{ $t("competitionList.stage") }}:
                        <span>{{
                          scope.row.nowTaskName || $t("common.null")
                        }}</span>
                      </p>
                      <p style="color: #9aa1a8">
                        {{ $t("competitionList.nextRound") }}:
                        <span v-if="scope.row.nextRound">
                          {{ $t("competitionList.nextRoundTrue") }}
                        </span>
                        <span v-else>
                          {{ $t("competitionList.nextRoundFalse") }}
                        </span>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="team"
                    :label="$t('table.team')"
                    min-width="50%"
                  >
                    <template
                      slot-scope="scope"
                      v-if="scope.row.qualificationId !== null"
                    >
                      <div v-if="scope.row.name.includes('Part2')">
                        {{ $t("competitionList.teamInfoTip") }}
                      </div>
                      <TeamEdit
                        :participants="scope.row.addonsList"
                        :memberLimit="scope.row.memberLimit"
                        :mentorLimit="scope.row.mentorLimit"
                        :mentorEditable="scope.row.addOnsTeacherEditable"
                        :memberEditable="scope.row.addOnsStudentEditable"
                        :isTeam="scope.row.isTeam"
                        :qualification-id="scope.row.qualificationId"
                        v-else
                        @update_team="update_competition(scope.$index)"
                      >
                      </TeamEdit>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="join"
                    :label="$t('table.operation')"
                    min-width="30%"
                  >
                    <template v-slot="scope">
                      <el-button
                        v-if="!scope.row.isQualified && scope.row.allowEnter"
                        @click="handleEnterCompetition(scope.row)"
                        type="primary"
                        size="small"
                        >{{ $t("competitionList.signUp") }}
                      </el-button>
                      <el-button
                        v-if="scope.row.isQualified"
                        @click="handleDoCompetition(scope.row)"
                        type="success"
                        size="small"
                        >{{ $t("competitionList.enter") }}
                      </el-button>
                      <el-button
                        v-if="scope.row.isQualified && scope.row.allowQuit"
                        @click="handleQuitCompetition(scope.row)"
                        type="danger"
                        size="small"
                        >{{ $t("competitionList.quit") }}
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
          </div>
        </div>
      </div>
      <p></p>
    </div>
  </div>
</template>

<script>
import { competitionInfo } from "../../assets/staticData/competition";
import Leftbar from "../../components/newComponent/Leftbar";
import {
  competitionDescriptionGet,
  enterCompetition,
  quitCompetition,
  stuCompetitionGet,
  stuCompetitionListGet,
} from "../../api/competition";
import TeamEdit from "./TeamEdit";

export default {
  name: "competitionList",
  components: {
    TeamEdit,
    Leftbar,
  },
  bodyClass: "index-page",
  data() {
    return {
      competitionList: [],
      loading: false,
    };
  },
  beforeMount() {
    this.competitionInfo = competitionInfo;
  },
  mounted() {
    this.initCompetitionList();
    this.checkUserInfoCompleted();
  },
  methods: {
    initCompetitionList() {
      this.loading = true;
      stuCompetitionListGet().then((res) => {
        this.competitionList = res;
        // console.log(this.competitionList);
        this.loading = false;
      });
    },
    //报名 todo
    handleEnterCompetition(competition) {
      if (!this.checkUserInfoCompleted()) {
        return;
      }
      let that = this;
      const h = this.$createElement;
      let teamNotice = competition.isTeam
        ? that.$t("competitionList.teamTip")
        : "";
      competitionDescriptionGet(competition.id).then((res) => {
        this.$msgbox({
          title: that.$t("common.confirmTitle"),
          message: h("div", null, [
            h("p", null, res.description),
            h("br", null, ""),
            h("p", { style: "color: red" }, teamNotice),
          ]),
          showCancelButton: true,
          confirmButtonText: that.$t("button.confirm"),
          cancelButtonText: that.$t("button.cancel"),
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              enterCompetition(competition.id).then((res) => {
                if (res.data) {
                  this.$notify({
                    type: "success",
                    title: res.message,
                    duration: 3000,
                    message: "",
                  });
                  done();
                  this.initCompetitionList();
                } else {
                  that.$notify({
                    type: "warning",
                    title: that.$t("common.error"),
                    duration: 3000,
                    message: that.$t("common.permissionWarning"),
                  });
                }
              });
            } else {
              done();
            }
          },
        });
      });
    },
    handleQuitCompetition(competition) {
      let that = this;
      this.$confirm(
        that.$t("competitionList.quitTip"),
        that.$t("common.reminder"),
        {
          confirmButtonText: that.$t("button.confirm"),
          cancelButtonText: that.$t("button.cancel"),
          type: "warning",
        },
      ).then(() => {
        quitCompetition(competition.id)
          .then((res) => {
            this.$notify({
              type: "success",
              title: this.$t("common.success"),
              duration: 3000,
            });
            this.initCompetitionList();
          })
          .catch((err) => {
            this.$notify({
              type: "error",
              title: this.$t("common.fail"),
              message: err.response.data.message,
              duration: 3000,
            });
          });
      });
    },
    //参赛
    handleDoCompetition(c) {
      if (!this.checkUserInfoCompleted()) {
        return;
      }
      if (!c.name.includes("Web")) {
        this.$router.push({
          name: "CompetitionDetail",
          params: {
            id: c.examId,
          },
        });
        return;
      }
      let that = this;
      this.$alert(
        that.$t("competitionList.part2tip"),
        that.$t("common.reminder"),
        {
          confirmButtonText: this.$t("button.confirm"),
          type: "warning",
        },
      ).then(() => {
        this.$router.push({
          name: "CompetitionDetail",
          params: {
            id: c.examId,
          },
        });
      });
    },
    //更新大赛信息
    update_competition(index) {
      let competitionId = this.competitionList[index].id;
      stuCompetitionGet(competitionId).then((res) => {
        this.$set(this.competitionList, index, res);
      });
    },
    //参赛须知 todo
    competitionNotice(id) {
      let that = this;
      competitionDescriptionGet(id).then((res) => {
        that.$alert(res.description, that.$t("competitionList.contestRule"));
      });
    },
    userInfoCompleted() {
      if (
        localStorage.getItem("user") === "" ||
        localStorage.getItem("user") === null
      ) {
        return false;
      }
      // 省份、学校、指导教师姓名、指导教师邮箱
      let user = JSON.parse(localStorage.getItem("user"));
      return (
        user.name !== undefined &&
        user.name.length > 0 &&
        user.email !== undefined &&
        user.email.length > 0 &&
        user.school !== undefined &&
        user.school.length > 0 &&
        user.province !== undefined &&
        user.province.length > 0 &&
        ((user.menuMap !== undefined && user.menuMap.manager?.length != 0) ||
          (user.teacher_email !== undefined && user.teacher_email.length > 0))
      );
    },
    checkUserInfoCompleted() {
      let that = this;
      if (!this.userInfoCompleted()) {
        this.$confirm(
          that.$t("competitionList.profileTip"),
          that.$t("common.reminder"),
          {
            confirmButtonText: that.$t("competitionList.goToFill"),
            cancelButtonText: that.$t("button.cancel"),
            type: "warning",
          },
        ).then(() => {
          this.$router.push("/profile");
        });
      } else {
        return true;
      }
    },
  },
};
</script>
<style lang="scss">
@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
<style scoped>
.info_title {
  font-size: 22px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 12px;
}

.competition_notice {
  text-decoration: underline;
  color: red;
  margin-left: 1em;
  cursor: pointer;
  font-size: small;
}

.new_icon {
  display: inline-block;
  font-style: italic;
  color: orangered;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
}
</style>
